import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=d2989f38&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2989f38')) {
      api.createRecord('d2989f38', component.options)
    } else {
      api.reload('d2989f38', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=d2989f38&", function () {
      api.rerender('d2989f38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2oICB6BKEZJ4t/JS/offershelp.vue"
export default component.exports